
import BaseApi from "./BaseApi";

export default class EvaluationsService extends BaseApi {


    constructor(){
        super();
    }
 
    /**
     * INDEX
     */
    async index()
    {
        return this.http.get(`${this.baseUrl}/performance-evaluation`)
        .catch(this.handleErrorResponse);
    }

    async get(evaluationId)
    {
        return this.http.get(`${this.baseUrl}/performance-evaluation/${evaluationId}`)
        .catch(this.handleErrorResponse);
    }

    async getWithToken(evaluationId,token)
    {
        return this.http.get(`${this.baseUrl}/performance-evaluation/${evaluationId}/detail/${token}`)
        .catch(this.handleErrorResponse);
    }

    async notify(evaluationId)
    {
        return this.http.get(`${this.baseUrl}/performance-evaluation/${evaluationId}/notify`)
        .catch(this.handleErrorResponse);
    }

    async delete(evaluationId)
    {
        return this.http.delete(`${this.baseUrl}/performance-evaluation/${evaluationId}`)
        .catch(this.handleErrorResponse);
    }

    async store(data)
    {
        return this.http.post(`${this.baseUrl}/performance-evaluation`, data)
        .catch(this.handleErrorResponse);
    }

   
    async storeQuestion(data)
    {
        return this.http.post(`${this.baseUrl}/performance-evaluation/questions`, data)
        .catch(this.handleErrorResponse);
    }

    async storeAnswer(evaluationId, employeeId, data)
    {
        return this.http.post(`${this.baseUrl}/performance-evaluation/${evaluationId}/save-answers/${employeeId}`, data)
        .catch(this.handleErrorResponse);
    }

     async storeAnswerWithToken(evaluationId, employeeId, token, data)
    {
        return this.http.post(`${this.baseUrl}/performance-evaluation/${evaluationId}/store-answers/${employeeId}/${token}`, data)
        .catch(this.handleErrorResponse);
    }

}